import { render, staticRenderFns } from "./testimonies.vue?vue&type=template&id=75ec86ac&scoped=true&"
import script from "./testimonies.vue?vue&type=script&lang=js&"
export * from "./testimonies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ec86ac",
  null
  
)

export default component.exports